import { Col, Flex, Row } from "antd"
import ClientDetails from "./ClientDetails"
import ExperienceDetails from "./ExperienceDetails"
import PaymentSummary from "./PaymentSummary"
import PaymentHistory from "./PaymentHistory"
import PropTypes from "prop-types"
import { useEffect } from "react"
import { useDispatch } from "react-redux"
import { setClientId } from "store/bookings"
import PriceChangeHistory from "./PaymentSummary/PriceChangeHistory"
import NotesAndQuestionnaire from "./NotesAndQuestionnaire"

const BookingDetailsBody = ({ booking }) => {
  const dispatch = useDispatch()
  const {
    payment_summary = {},
    payment_status = "",
    payment_history = [],
    email_templates_collection,
    text_templates_collection,
    uuid,
    id,
    booking_status,
    client,
    original_price_history,
    price_change_histories,
    custom_fees
  } = booking || {}

  const hasPayments = payment_history?.length > 0
  const clientWithTemplates = {
    ...client,
    ...(email_templates_collection && { email_templates_collection }),
    ...(text_templates_collection && { text_templates_collection })
  }

  useEffect(() => {
    if (client?.user_id) {
      dispatch(setClientId(client?.user_id))
    }
  }, [client?.user_id, dispatch])

  return (
    <Row gutter={16}>
      <Col xs={24} lg={14}>
        <Flex vertical gap={16}>
          <ClientDetails client={clientWithTemplates} />

          <PaymentSummary
            paymentSummary={payment_summary}
            customFees={custom_fees ?? []}
            payment_status={payment_status}
            hasPayments={hasPayments}
            bookingUUID={uuid}
            bookingId={id}
            bookingStatus={booking_status}
          />
          <PriceChangeHistory originalPriceHistory={original_price_history} priceChangeHistories={price_change_histories} />
          {hasPayments && (
            <PaymentHistory
              paymentHistory={payment_history}
              bookingStatus={booking_status}
              bookingUUID={uuid}
              remainingBalance={payment_summary?.remaining_balance}
              paymentStatus={payment_status}
            />
          )}
        </Flex>
      </Col>
      <Col xs={24} lg={10}>
        <Flex vertical gap={16}>
          <ExperienceDetails booking={booking} />
          <NotesAndQuestionnaire booking={booking} />
        </Flex>
      </Col>
    </Row>
  )
}

BookingDetailsBody.propTypes = {
  booking: PropTypes.shape({
    client: PropTypes.shape({
      name: PropTypes.string,
      email: PropTypes.string,
      phone: PropTypes.string,
      email_templates_collection: PropTypes.array,
      text_templates_collection: PropTypes.array
    }),
    experience: PropTypes.shape({
      title: PropTypes.string,
      description: PropTypes.string,
      price: PropTypes.number,
      photos: PropTypes.arrayOf(
        PropTypes.shape({
          url: PropTypes.string
        })
      )
    })
  })
}

export default BookingDetailsBody
